/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPotteryWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPotteryWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Create with Clay!",
    "Pottery Awaits!",
    "Let’s Get Crafty!",
  ],
  title: "Pottery Workshop",
  description: "Organize a fun pottery workshop.",
  longDescription:
    "Gather your friends for a creative pottery workshop! Choose a date, decide on pieces to create, and plan snacks for the session!",
  emoji: "🖌",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Pottery Workshop",
          emoji: "🖌",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the pottery workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on pottery pieces to create?",
            description: "What pottery pieces should we make in the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What pottery pieces should we create?",
                emoji: "🍶",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we have during the workshop?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍪",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we serve?",
                      emoji: "☕",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Creative!",
    outroDescription:
      "Your pottery workshop plans are set! Enjoy crafting with clay!",
  },
};
